<div class="labeling-central-tile">
    <div
        class="labeling-field"
        [ngClass]="{
            active:
                showImageContainer &&
                selectedImage?.processedUrl &&
                !selectedImage?.error &&
                isImageAndAnnotationsReady,
            shrink:
                !showImageContainer ||
                !selectedImage?.processedUrl ||
                selectedImage?.error ||
                !isImageAndAnnotationsReady
        }"
    >
        <div class="current-image">
            <div #panzoomParent class="current-image-inner">
                <ngx-panzoom
                    class="pan-zoom"
                    [zoomLevels]="panZoomConfig.zoomLevels"
                    [initialZoomLevel]="panZoomConfig.neutralZoomLevel"
                    [scalePerZoomLevel]="panZoomConfig.scalePerZoomLevel"
                    [neutralZoomLevel]="panZoomConfig.neutralZoomLevel"
                    [zoomOnMouseWheel]="panZoomConfig.zoomOnMouseWheel"
                    [zoomOnDoubleClick]="panZoomConfig.zoomOnDoubleClick"
                    [invertMouseWheel]="panZoomConfig.invertMouseWheel"
                    [freeMouseWheel]="panZoomConfig.freeMouseWheel"
                    [panOnClickDrag]="zoomConfigPanOnClickDrag()"
                    [dragMouseButton]="panZoomConfig.dragMouseButton"
                    (modelChange)="onModelChanged($event)"
                    [zoomToFitZoomLevelFactor]="panZoomConfig.zoomToFitZoomLevelFactor"
                >
                    @if (selectedImage?.processedUrl && !selectedImage?.error && svgStatus) {
                        @if (showSizeLabels && initializeAnnotations) {
                            <svg
                                [attr.width]="svgStatus.w"
                                [attr.height]="svgStatus.h"
                                [attr.viewBox]="svgStatus.viewBox"
                                preserveAspectRatio="xMidYMid meet"
                                id="backbuffer"
                            >
                                <ng-container
                                    *ngFor="let annotation of annotations"
                                >
                                    <g
                                        *ngIf="
                                            !!initializedSizeLabels[
                                                annotation.id
                                            ] && imageLoaded
                                        "
                                    >
                                        <text
                                            #heightLabelInit
                                            class="size-label-text"
                                        >
                                            {{
                                                getHeightLabelData(annotation,
                                                    heightLabelInit).text.text
                                            }}
                                        </text>
                                        <text #widthLabelInit class="size-label-text">
                                            {{
                                                getWidthLabelData(annotation,
                                                    widthLabelInit).text.text
                                            }}
                                        </text>
                                    </g>
                                </ng-container>
                            </svg>
                        }
                        <img
                            #currentImage
                            (load)="onImageLoad()"
                            [src]="selectedImage?.processedUrl"
                            [alt]="selectedImage?.id"
                            [style.visibility]="
                                isImageAndAnnotationsReady ? 'visible' : 'hidden'
                            "
                        />
                        <svg
                            [ngStyle]="{
                            cursor: cursorView
                        }"
                            (mousedown)="onHandleMouseAction()"
                            id="labeling"
                            #labeling
                            [attr.width]="svgStatus.w"
                            [attr.height]="svgStatus.h"
                            [attr.viewBox]="svgStatus.viewBox"
                            preserveAspectRatio="xMidYMid meet"
                            *ngIf="isImageAndAnnotationsReady"
                        >
                            <g
                                *ngFor="let annotation of annotations"
                                class="annotation-box"
                                [ngClass]="{
                                  active: annotation.active,
                                  selectable: !isDraggingActive
                                }"
                                (click)="selectAnnotation(annotation)"
                            >
                                <ng-container *ngIf="showSizeLabels">
                                    <g>
                                        <rect class="size-label-rect bounding-box"
                                            [ngStyle]="{
                                            stroke: annotation.active
                                                ? 'white'
                                                : getColor(
                                                    getImgCategoryName(
                                                        annotation.categoryId
                                                    )
                                                ),
                                            fill: annotation.active
                                                ? 'white'
                                                : getColor(
                                                    getImgCategoryName(
                                                        annotation.categoryId
                                                    )
                                                )
                                        }"
                                            [attr.x]="getHeightLabelData(annotation, heightLabel).x"
                                            [attr.y]="getHeightLabelData(annotation, heightLabel).y"
                                            [attr.width]="getHeightLabelData(annotation, heightLabel).width"
                                            [attr.height]="getHeightLabelData(annotation, heightLabel).height"
                                        ></rect>
                                        <text
                                            #heightLabel
                                            [id]="annotation.id + '_h'"
                                            [class]="{'size-label-text': true, 'size-label-text-active': annotation.active}"
                                            [attr.x]="getHeightLabelData(annotation, heightLabel).text.x"
                                            [attr.y]="getHeightLabelData(annotation, heightLabel).text.y"
                                            [attr.transform]="getHeightLabelData(annotation, heightLabel).text.transform">
                                            {{
                                                getHeightLabelData(annotation,
                                                    heightLabel).text.text
                                            }}
                                        </text>
                                        <rect class="size-label-rect bounding-box"
                                            [ngStyle]="{
                                                stroke: annotation.active
                                                    ? 'white'
                                                    : getColor(
                                                        getImgCategoryName(
                                                            annotation.categoryId
                                                        )
                                                    ),
                                                fill: annotation.active
                                                    ? 'white'
                                                    : getColor(
                                                        getImgCategoryName(
                                                            annotation.categoryId
                                                        )
                                                    )
                                            }"
                                            [attr.x]="getWidthLabelData(annotation, widthLabel).x"
                                            [attr.y]="getWidthLabelData(annotation, widthLabel).y"
                                            [attr.width]="getWidthLabelData(annotation, widthLabel).width"
                                            [attr.height]="getWidthLabelData(annotation, widthLabel).height"
                                        ></rect>
                                        <text
                                            #widthLabel
                                            [id]="annotation.id + '_w'"
                                            [class]="{'size-label-text': true, 'size-label-text-active': annotation.active}"
                                            [attr.x]="getWidthLabelData(annotation, widthLabel).text.x"
                                            [attr.y]="getWidthLabelData(annotation, widthLabel).text.y"
                                        >
                                            {{
                                                getWidthLabelData(annotation, widthLabel).text.text
                                            }}
                                        </text>
                                    </g>
                                </ng-container>
                                <rect
                                    [id]="annotation.id"
                                    [ngStyle]="{
                                    stroke: annotation.active
                                        ? 'white'
                                        : getColor(
                                              getImgCategoryName(
                                                  annotation.categoryId
                                              )
                                          )
                                }"
                                    class="bounding-box"
                                    [attr.x]="annotation.bbox.x"
                                    [attr.y]="annotation.bbox.y"
                                    [attr.width]="annotation.bbox.width"
                                    [attr.height]="annotation.bbox.height"
                                ></rect>
                                <rect
                                    class="title-box"
                                    [ngStyle]="{
                                        fill: annotation.active
                                            ? 'white'
                                            : getColor(
                                                getImgCategoryName(
                                                    annotation.categoryId
                                                )
                                            ),
                                        stroke: annotation.active
                                            ? 'white'
                                            : getColor(
                                                getImgCategoryName(
                                                    annotation.categoryId
                                                )
                                            )
                                    }"
                                    [attr.x]="annotation.bbox.x"
                                    [attr.y]="annotation.bbox.y - boundingBoxTitleHeight"
                                    [attr.width]="annotation.bbox.width"
                                    [attr.height]="boundingBoxTitleHeight"
                                ></rect>
                                <text class="title"
                                    [attr.x]="annotation.bbox.x + cornerSize"
                                    [attr.y]="annotation.bbox.y - 6"
                                >
                                    {{ getImgCategoryName(annotation.categoryId) }}
                                </text>
                            </g>
                        </svg>
                    }
                </ngx-panzoom>
            </div>
        </div>
        <div *ngIf="canEdit">
            <div
                class="corner top-left"
                (mousedown)="onHandleBoundingBoxResize($event)"
                alt="Resize"
            ></div>
            <div
                class="corner top-right"
                (mousedown)="onHandleBoundingBoxResize($event)"
                alt="Resize"
            ></div>
            <div
                class="corner bottom-left"
                (mousedown)="onHandleBoundingBoxResize($event)"
                alt="Resize"
            ></div>
            <div
                class="corner bottom-right"
                (mousedown)="onHandleBoundingBoxResize($event)"
                alt="Resize"
            ></div>
            <img
                [style]="
                    'position: fixed; visibility: ' +
                    (annotationStateService.selectedAnnotation
                        ? 'visible'
                        : 'hidden') +
                    ';width: ' +
                    moveButtonHeight +
                    'px; height: ' +
                    moveButtonHeight +
                    'px;'
                "
                id="move-bounding-box-button"
                src="assets/svg/img-db/labeling-dialog/move.svg"
                (mousedown)="onActivateBoundingBoxMovement($event)"
                alt="Move Button"
            />
        </div>
        <div class="feature-buttons-wrapper" *ngIf="isImageAndAnnotationsReady && showImageContainer">
            <button
                id="undo-button"
                [disabled]="!annotationStateService.hasUndo() || !canEdit"
                [ngClass]="{
                    disabled: !annotationStateService.hasUndo()
                }"
                (click)="annotationStateService.undo()"
                (mouseenter)="featureButtonActiveIdx = 0"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.undo' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/undo' +
                        (annotationStateService.hasUndo() &&
                        featureButtonActiveIdx === 0
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="undo-icon"
                />
            </button>
            <button
                id="redo-button"
                [disabled]="!annotationStateService.hasRedo() || !canEdit"
                [ngClass]="{
                    disabled: !annotationStateService.hasRedo()
                }"
                (click)="annotationStateService.redo()"
                (mouseenter)="featureButtonActiveIdx = 1"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.redo' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/redo' +
                        (annotationStateService.hasRedo() &&
                        featureButtonActiveIdx === 1
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="redo-icon"
                />
            </button>
            <button
                id="pan-button"
                [disabled]="currentZoomLevel <= 0"
                (click)="onPanButtonClick()"
                [ngClass]="{
                    disabled: currentZoomLevel <= 0,
                    active: isPanButtonActive
                }"
                (mouseenter)="featureButtonActiveIdx = 2"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.pan' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/pan' +
                        ((currentZoomLevel > 0 &&
                            featureButtonActiveIdx === 2) ||
                        isPanButtonActive
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="pan-icon"
                />
            </button>
            <button
                id="ruler-button"
                (click)="onRulerButtonClick()"
                [ngClass]="{ active: isRulerButtonActive }"
                (mouseenter)="featureButtonActiveIdx = 3"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.ruler' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/ruler' +
                        ((featureButtonActiveIdx === 3) ||
                        isRulerButtonActive
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="ruler-icon"
                />
            </button>
        </div>
    </div>
    <div class="d-flex justify-content-center" *ngIf="!showImageContainer || (showImageContainer &&
    selectedImage?.processedUrl &&
    !selectedImage?.error &&
    !isImageAndAnnotationsReady)">
        <div class="tryb-design-spinner"></div>
    </div>
    <div
        *ngIf="
            showImageContainer &&
            !selectedImage?.processedUrl &&
            !selectedImage?.error
        "
        class="w-100"
    >
        <img
            alt="spinner"
            src="assets/img/img-db/spinner.gif"
            class="img-fluid spinner"
        />
        <div class="text-center message">
            {{ 'imgDb.imgLabeling.stillProcess' | translate }}
        </div>
    </div>
    <div *ngIf="showImageContainer && selectedImage?.error">
        <div class="text-center message">
            {{ 'imgDb.imgLabeling.imgError' | translate }}
        </div>
    </div>
</div>
